// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"0a3bd127","369":"bafac12c","489":"42f7960e","490":"36e55167","687":"dba180b0","757":"52c1a2fe"}[chunkId] + ".chunk.js";
};